/**
 * @fileoverview Shared mock adapter for the sales feature.
 * @description The one axios-mock-adapter instance for every sales endpoint, created once and
 * gated by VITE_ENABLE_MOCK_API — mirrors features/auth's auth-mock-adapter.ts exactly, and for
 * the same reason: axios-mock-adapter installs itself by overwriting the axios instance's
 * defaults.adapter, so a second `new MockAdapter(httpClient)` elsewhere would silently replace
 * this one and drop its registered routes. Every per-domain mock module in this feature
 * (dashboard, clients, pipeline, team, performance, my-targets, users) registers its handlers on
 * this single shared instance instead of constructing its own. `onNoMatch: 'passthrough'` chains
 * this adapter to whichever one was active before it (notifications, then auth — see
 * auth-mock-adapter.ts) so a miss here falls through to them instead of 404ing.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import MockAdapter from 'axios-mock-adapter'

import { appConfig } from '@/config/app-config'
import { httpClient } from '@/shared/api/http-client'

export const salesMockAdapter = appConfig.enableMockApi
  ? new MockAdapter(httpClient, { delayResponse: 500, onNoMatch: 'passthrough' })
  : null
